import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientQuote, CustomHttpResponse, HydraCollectionResponse } from '../../../models';
import { ApiHttpService } from '../../../services';

@Injectable({
  providedIn: 'root',
})
export class ClientQuoteService {
  apiService: ApiHttpService<ClientQuote> = inject(ApiHttpService<ClientQuote>);

  getClientQuoteByIri(iri: string): Observable<ClientQuote> {
    
    return this.apiService.get(iri).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientQuote>) => result.body),
    );
  }

  getClientQuotes(): Observable<ClientQuote[]> {
    return this.apiService.getMany(`/client_quotes`).pipe(map((result) => result.body['hydra:member']));
  }

  getClientQuoteByFilter(filters: string[]): Observable<ClientQuote[]> {
    const url = filters && filters.length ? `/client_quotes?${filters.join('&')}` : `/client_quotes`;
    return this.apiService
      .getMany(url)
      .pipe(map((result: CustomHttpResponse<HydraCollectionResponse<ClientQuote>>) => result.body['hydra:member']));
  }

  downloadPdf(iri: string) {
    return this.apiService.downloadFileAsBlob(`${iri}/download_pdf`);
  }

  update(iri: string, update: ClientQuote): Observable<ClientQuote> {
    return this.apiService.patch(iri, update).pipe(map((result: CustomHttpResponse<ClientQuote>) => result.body));
  }

  create(clientQuote: ClientQuote): Observable<ClientQuote> {
    return this.apiService
      .post(`/client_quotes`, clientQuote)
      .pipe(map((result: CustomHttpResponse<ClientQuote>) => result.body));
  }

  delete(clientQuote: ClientQuote) {
    return this.apiService.delete(`/client_quotes/${clientQuote.id}`).pipe(map((result) => result));
  }
}
